import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';
import { useEffect } from 'react';

const ContactPage = () => {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtadilatfirmasi.com web siteniz üzerinden yazıyorum.\nTadilat, dekorasyon ve iç mimarlık hizmetleriniz hakkında bilgi ve fiyat teklifi almak istiyorum.');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-cream">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-wood/5 to-transparent">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-wood-dark mb-6">
              İletişim
            </h1>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              Projeleriniz için bizimle iletişime geçin. Size en kısa sürede dönüş yapalım.
            </p>
          </div>
        </div>
      </section>

      {/* İletişim Bilgileri */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {/* Telefon */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-wood/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-phone-line text-3xl text-wood"></i>
              </div>
              <h3 className="text-xl font-semibold text-wood-dark mb-3">Telefon</h3>
              <a
                href="tel:05421138110"
                className="text-gray-600 hover:text-wood transition-colors cursor-pointer"
              >
                0542 113 81 10
              </a>
            </div>

            {/* E-posta */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-wood/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-mail-line text-3xl text-wood"></i>
              </div>
              <h3 className="text-xl font-semibold text-wood-dark mb-3">E-posta</h3>
              <a
                href="mailto:izmirtadilatfirmasi@gmail.com"
                className="text-gray-600 hover:text-wood transition-colors cursor-pointer break-all"
              >
                izmirtadilatfirmasi@gmail.com
              </a>
            </div>

            {/* Adres */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-all duration-300">
              <div className="w-16 h-16 bg-wood/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-line text-3xl text-wood"></i>
              </div>
              <h3 className="text-xl font-semibold text-wood-dark mb-3">Adres</h3>
              <p className="text-gray-600">
                Mehmet Ali Akman Mahallesi 20/1 Sokak No:5
                <br />
                Konak / İzmir
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Harita */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-wood-dark text-center mb-12">
              Bizi Ziyaret Edin
            </h2>
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3127.8!2d27.1!3d38.4!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzjCsDI0JzAwLjAiTiAyN8KwMDYnMDAuMCJF!5e0!3m2!1str!2str!4v1234567890"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="İzmir Tadilat Firması Konum"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-b from-wood/5 to-transparent">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-wood-dark mb-6">
              Hemen Arayın, Ücretsiz Keşif Yapılsın
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Projeleriniz için detaylı bilgi almak ve ücretsiz keşif randevusu oluşturmak için bizi arayın.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="tel:05421138110"
                className="inline-flex items-center space-x-2 px-8 py-4 bg-wood hover:bg-wood-dark text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-lg"></i>
                <span>Hemen Ara</span>
              </a>
              <a
                href={`https://wa.me/905421138110?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 px-8 py-4 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default ContactPage;
